"use client";
import dynamic from "next/dynamic";
import Link from "next/link";
import { Button } from "../../components/ui/button";
import { Calendar, Check, Hotel, Users as UsersIcon, Star } from "lucide-react";
import { motion } from "motion/react";
import { useAppSelector } from "../../_hooks/hooks";
import { formatPhoneForDisplay, cleanPhoneForTel } from "../../_helper/helper";

// Dynamic Imports
const Preloader = dynamic(() =>
  import("../../components/Preloader").then((mod) => mod.Preloader),
);
const RoomPricingSection = dynamic(
  () => import("./components/RoomPricingSection"),
);
const PackageInclusionSection = dynamic(
  () => import("./components/PackageInclusionSection"),
);
const PolicySection = dynamic(() => import("./components/PolicySection"));

export function PackageDetail({ initialData }: { initialData?: any }) {
  // const dispatch = useAppDispatch();
  // const pathname = usePathname();
  // const params = useParams();
  // const PackageURL = params?.PackageURL as string;
  const loading = useAppSelector((state: any) => state.package.loading);
  const SettingList = useAppSelector((state: any) => state.home.SettingList);
  // const storePackageDetail = useAppSelector(
  //   (state: any) => state.package.PackageDetail,
  // );
  // const CMSList = useAppSelector((state: any) => state.home.CMSList);

  const PackageDetail = initialData;
  // const PackageDetail =
  //   Object.keys(storePackageDetail || {}).length > 0 && storePackageDetail?.ID
  //     ? storePackageDetail
  //     : initialData;

  // const fullURL =
  //   typeof window !== "undefined"
  //     ? `${window.location.origin}${pathname}`
  //     : pathname;

  // const [lookUpCMSData, setLookUpCMSData] = useState<Record<string, ICMS>>({});

  const WhatsAppNo = SettingList?.filter(
    (setting: any) => setting?.SettingKey === "WhatsAppNo",
  )[0]?.SettingValue;
  const phone = WhatsAppNo ? WhatsAppNo.replace(/\D+/g, "") : "";
  const whatsappLink = `https://wa.me/${phone}?text=${encodeURIComponent("Hello, I'd like to know more details about the package.")}`;

  // Format currency
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Format date
  const formatDate = (dateString: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // useEffect(() => {
  //   if (CMSList && CMSList?.length > 0) {
  //     setLookUpCMSData(createLookupObject(CMSList, "Name"));
  //   }
  // }, [CMSList]);

  // Hydrate store and prevent re-fetch if initialData exists
  // useEffect(() => {
  //   if (
  //     initialData &&
  //     (!storePackageDetail ||
  //       Object.keys(storePackageDetail).length === 0 ||
  //       !storePackageDetail.ID)
  //   ) {
  //     import("./packageSlice").then((mod) => {
  //       dispatch(mod.setPackageDetail(initialData));
  //     });
  //   } else if (PackageURL) {
  //     dispatch(getPackagesByURL(PackageURL));
  //   }
  //   // dispatch(getAllCMSByURL("package"));
  // }, [PackageURL, dispatch, initialData]);

  return (
    <>
      {loading && <Preloader />}
      <div className="min-h-screen bg-white text-md">
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-end justify-center overflow-hidden">
          <div
            className="absolute inset-0 z-0"
            style={{
              backgroundImage: `url('${PackageDetail?.BannerImage || PackageDetail?.MainImage}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70" />
          </div>

          <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 mt-25 mb-15">
            <div className="max-w-4xl mx-auto">
              {/* <div className="inline-block px-6 py-3 bg-white/10 backdrop-blur-md border border-white/20 rounded-full mb-6">
                <p className="text-[#C9A962] tracking-[0.4em] text-sm">
                  {PackageDetail?.City?.toUpperCase()} PACKAGE
                </p>
              </div> */}
              {initialData?.IsFree && (
                <div
                  className="animate-bounce text-white text-5xl md:text-6xl lg:text-7xl mb-8"
                  dangerouslySetInnerHTML={{
                    __html: initialData?.FreeTitle,
                  }}
                />
              )}
              <h1 className="text-[#C9A962] text-3xl md:text-4xl lg:text-5xl leading-tight font-playfair">
                {PackageDetail?.PackageTitle}
              </h1>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              {/* Left Column - Package Details */}
              <div className="lg:col-span-2 space-y-12">
                <div className="flex flex-wrap justify-start items-center gap-6">
                  <div className="flex items-center gap-2">
                    <Hotel className="h-5 w-5 text-[#C9A962]" />
                    <span className="text-lg">
                      {PackageDetail?.PropertyName}
                    </span>
                  </div>
                  {/* <div className="flex items-center gap-2">
                    <Calendar className="h-5 w-5 text-[#C9A962]" />
                    <span className="text-lg">
                      Valid until {formatDate(PackageDetail?.ValidityPeriod)}
                    </span>
                  </div> */}
                  <div className="flex items-center gap-2">
                    <UsersIcon className="h-5 w-5 text-[#C9A962]" />
                    <span className="text-lg">
                      {PackageDetail?.Roompricingdetails?.length || 0} Room
                      Categories
                    </span>
                  </div>
                </div>

                {/* Package Inclusions */}
                <PackageInclusionSection
                  inclusionHTML={PackageDetail?.PackageInclusion}
                />

                {/* Room Pricing Details */}
                <RoomPricingSection
                  roomPricingDetails={PackageDetail?.Roompricingdetails}
                  formatCurrency={formatCurrency}
                />

                {/* Policies */}
                <PolicySection
                  childPolicyHTML={PackageDetail?.ChildPolicy}
                  cancellationPolicyHTML={PackageDetail?.CancellationPolicy}
                />
              </div>

              {/* Right Column - Booking Sidebar */}
              <div>
                <div className="sticky top-20 space-y-8">
                  {/* Booking Card */}
                  <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden"
                  >
                    <div className="p-8">
                      <div className="mb-6">
                        {initialData?.IsFree && (
                          <div
                            className="tooltip animate-bounce"
                            dangerouslySetInnerHTML={{
                              __html: initialData?.FreeTitle,
                            }}
                          />
                        )}
                        <div className="text-2xl font-bold text-[#1A1A1A] mb-2">
                          Starting from
                        </div>
                        <div className="text-4xl font-bold text-[#B42025]">
                          <span>*</span>
                          {(() => {
                            const roompricingdetails =
                              PackageDetail?.Roompricingdetails || [];
                            const oneNightRates = roompricingdetails
                              ?.filter((r: any) => r?.OneNightRate > 0)
                              ?.map((r: any) => r?.OneNightRate);
                            const twoNightRates = roompricingdetails
                              ?.filter((r: any) => r?.TwoNightRate > 0)
                              ?.map((r: any) => r?.TwoNightRate);

                            if (oneNightRates?.length > 0) {
                              return formatCurrency(Math.min(...oneNightRates));
                            } else if (twoNightRates?.length > 0) {
                              return formatCurrency(Math.min(...twoNightRates));
                            }
                            return "";
                          })()}
                          <span className="text-xs text-gray-500">
                            {` + Tax`}
                          </span>
                        </div>
                        <div className="text-gray-500">
                          {(() => {
                            const roompricingdetails =
                              PackageDetail?.Roompricingdetails || [];
                            const hasOneNight = roompricingdetails?.some(
                              (r: any) => r?.OneNightRate > 0,
                            );
                            if (hasOneNight) return "per room, per night";
                            const hasTwoNight = roompricingdetails?.some(
                              (r: any) => r?.TwoNightRate > 0,
                            );
                            if (hasTwoNight) return "per room";
                            return "per room, per night";
                          })()}
                        </div>
                      </div>

                      <div className="space-y-4">
                        {/* <Button
                          size="lg"
                          className="w-full bg-[#B42025] hover:bg-[#8F1A1E] text-white py-6 text-lg"
                          asChild
                        >
                          {PackageDetail.BookingURL ? (
                            <a
                              href={PackageDetail.BookingURL}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Book Now
                            </a>
                          ) : (
                            <Link href="/kavish-hotels-and-resorts-contact-details/">
                              Book Now
                            </Link>
                          )}
                        </Button> */}
                        {/* <Button
                          size="lg"
                          className="w-full bg-[#B42025] hover:bg-[#8F1A1E] text-white py-6 text-lg"
                          asChild
                        >
                          <a
                            href={whatsappLink || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <MessageCircle className="mr-2 h-6 w-6" />
                            Book on WhatsApp
                          </a>
                        </Button> */}

                        <Button
                          size="lg"
                          variant="outline"
                          className="w-full bg-[#B42025] hover:bg-[#8F1A1E] hover:text-white py-6 text-lg"
                          // className="w-full border-2 border-[#B42025] text-[#B42025] hover:bg-[#B42025] hover:text-white py-6 text-lg"
                          asChild
                        >
                          <Link
                            href={`tel:${cleanPhoneForTel(WhatsAppNo)}`}
                            className="text-white notranslate"
                            translate="no"
                          >
                            Call to Book
                          </Link>
                        </Button>
                        <Button
                          size="lg"
                          variant="outline"
                          className="w-full border-2 border-[#B42025] text-[#B42025] hover:bg-[#B42025] hover:text-white py-6 text-lg"
                          asChild
                        >
                          <Link
                            href={whatsappLink}
                            target="_blank"
                            className="notranslate"
                            translate="no"
                          >
                            Whatsapp to Book
                          </Link>
                        </Button>
                      </div>

                      <div className="mt-8 pt-8 border-t border-gray-200">
                        <h4 className="text-lg font-semibold text-[#1A1A1A] mb-4">
                          Why Book Direct?
                        </h4>
                        <ul className="space-y-3">
                          <li className="flex items-start gap-3">
                            <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                            <span className="text-sm text-gray-700">
                              Best Price Guaranteed
                            </span>
                          </li>
                          <li className="flex items-start gap-3">
                            <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                            <span className="text-sm text-gray-700">
                              Instant Confirmation
                            </span>
                          </li>
                          <li className="flex items-start gap-3">
                            <Check className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                            <span className="text-sm text-gray-700">
                              Priority Support
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </motion.div>

                  {/* Property Info */}
                  {/* <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.3 }}
                    className="bg-[#F9F7F4] rounded-2xl p-6"
                  >
                    <h3 className="text-xl font-semibold text-[#1A1A1A] mb-4">
                      Property Information
                    </h3>
                    <div className="space-y-3">
                      <div className="flex items-center gap-3">
                        <Hotel className="h-5 w-5 text-[#B42025]" />
                        <span className="text-gray-700">
                          {PackageDetail?.PropertyName}
                        </span>
                      </div>
                      <div className="flex items-center gap-3">
                        <Calendar className="h-5 w-5 text-[#B42025]" />
                        <span className="text-gray-700">
                          Valid until:{" "}
                          {formatDate(PackageDetail?.ValidityPeriod)}
                        </span>
                      </div>
                      <div className="flex items-center gap-3">
                        <Star className="h-5 w-5 text-[#B42025]" />
                        <span className="text-gray-700">
                          {PackageDetail?.City}
                        </span>
                      </div>
                    </div>
                  </motion.div> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-[#F9F7F4]">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
            {/* Check-in/Check-out Info */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className=" p-6"
            >
              <div className="flex items-center justify-center gap-3 mb-4">
                <div className="flex items-center gap-2">
                  <Hotel className="h-6 w-6 text-[#B42025]" />
                </div>
                <h3 className="text-2xl text-[#1A1A1A]">
                  Check-in & Check-out Information
                </h3>
              </div>
              <div
                className="prose prose-sm max-w-none checkin-out-info"
                dangerouslySetInnerHTML={{
                  __html: PackageDetail?.CheckinCheckoutInfo,
                }}
              />
            </motion.div>
          </div>
        </section>
      </div>
    </>
  );
}
